import { classNames } from "../../helpers";
import ChangeLangButton from "../language/ChangeLangButton";

type ContainerMdProps = {
  children?: React.ReactNode;
  className?: String;
  containerClassName?: String;
};

export default function ContainerMd({
  children,
  className,
  containerClassName,
}: ContainerMdProps) {
  return (
    <div
      className={classNames(
        "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8  min-h-screen flex",
        !!containerClassName ? containerClassName : "py-12"
      )}
    >
      <div className={classNames("max-w-3xl mx-auto w-full", className)}>
        {children}
      </div>
    </div>
  );
}
